import SearchParameters from "../models/SearchParameters";

export function isEmpty(searchParameters: SearchParameters) : boolean {
    return searchParameters.makes.length === 0 && searchParameters.models.length === 0 && searchParameters.locations.length === 0 &&
    searchParameters.colors.length === 0 && searchParameters.gearType === 0 && searchParameters.score === 0 
    && searchParameters.minOdom === 0 && searchParameters.maxOdom === 0 && searchParameters.minYear === 0 && searchParameters.lotNumber === 0
    && searchParameters.maxYear === 0 && searchParameters.minDisplacement === 0 && searchParameters.maxDisplacement === 0;

}